import React, {useEffect, useState} from 'react';
import {BiArrowBack} from 'react-icons/bi';
import {useNavigate} from 'react-router-dom';
import Footer from '../../components/Footer';
import HeaderPanel from '../../components/HeaderPanel';
import Loader from '../../components/Loader/Loader';
import {Entry} from 'contentful';

export interface AboutPageProps {}

const About = ({}: AboutPageProps) => {
  const navigate = useNavigate();

  return (
    <>
      <HeaderPanel />
      <div className="subpage">
        <div className="subpage-header">
          <BiArrowBack
            onClick={() => {
              navigate('/');
            }}
            className="back-button"
          />
          <h1>About</h1>
        </div>
        <div className="columns">
          <div className="col">
            <p>
              <strong>Central Europe-East Asia EV Nexus Tracker</strong> is one of
              the outputs of the <a href="https://ceias.eu/project-east-asian-electric-vehicle-makers-in-the-v4-countries-electric-vehicle-transition/">grant project</a> “East Asian electric vehicle makers in the V4 countries’ electric
              vehicle transition” coordinated by the <a href="https://ceias.eu/">Central European Institute of Asian Studies (CEIAS)</a> and supported by the <a href="https://www.visegradfund.org/">International Visegrad Fund</a>.
            </p>

            <p>
              The project studies the participation of East Asian EV carmakers
              in the V4 countries’ EV transition, and analyzes their strategies
              in navigating the local market and the political and economic
              dynamics in the V4 countries in attracting FDI in this sector. It
              will provide policy recommendations for policymakers to increase
              the V4 countries’ value-added through involvement in EV supply
              chains.
            </p>

            <p>
              <strong>Donor:</strong> <a href="https://www.visegradfund.org/">Visegrad Fund</a>
            </p>

            <p>
              <strong>CEIAS Partners: </strong>
              <a href="https://www.osw.waw.pl/en">OSW Centre for Eastern Studies (Poland)</a>,
              <a href="https://www.upol.cz/en/">Palacký University Olomouc (Czech Republic)</a>,
              <a href="https://www.uni-corvinus.hu/?lang=en">Corvinus University of Budapest (Hungary)</a>
            </p>

            <p>
              <strong>Duration:</strong> October 2024 – July 2025
            </p>

            <p>
              <strong>Contact:</strong> Filip Šebok (
              <a href="mailto:sebok@ceias.eu">sebok@ceias.eu</a>)
            </p>

            <h2>Methodology</h2>

            <p>The data was last updated on January 31, 2025.</p>

            <p>
              The data was compiled based on open-source research, using media
              reports, information provided by the investors, governments,
              national databases, and secondary research, with additional data
              sourced from the Bloomberg database.
            </p>

            <p>
              Where data on investment amount was missing, a placeholder value
              of 1 million was used to generate points on the map.
              <br/>
              The size of the points on the map is scaled logarithmically according to the investment amount.
            </p>

            <p>
              The date of exchange rate for conversion from the originally
              reported currencies to EUR was August 28, 2024, where applicable.
            </p>

            <p>
              In EV manufacturing, current and planned production in legacy
              automakers is displayed separately. In these cases, investment
              data on EV production and other relevant data regarding planned
              manufacturing is oftentimes missing due to the difficulty of
              separating the investment in new EV-related manufacturing versus
              existing manufacturing, both EV and non-EV-related. The amount of
              investment into retrofitting existing production lines is,
              however, generally significantly lower than investment into
              completely new greenfield projects.
            </p>

            <p>The capacity data refers to yearly production.</p>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default About;
